export default __webpack_public_path__ + "static/media/icon_check_empty.084022a1.svg";